"use client"

import { FlameKindling } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `FlameKindlingIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const FlameKindlingIcon = component(Icon)({ as: FlameKindling })
